import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppStore } from '../../stores'
import { useUserStore } from '../../stores'
import "./Signin.css";
import constants from "../../utils/constants";
import { getUserBaseUrl, getNavLinks, handleXhrError } from '../../utils'
import Logo from "../Logo";
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Cookies from 'js-cookie'
const ROLES = constants().ROLES;

const toastOptions = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};
//sweetalert
const MySwal = withReactContent(Swal);

const Signin = () => {
  const [role, setRole] = useState(ROLES.SUPER_ADMIN);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const showLoading = useAppStore(state => state.showLoading);
  const hideLoading = useAppStore(state => state.hideLoading);
  const userData = useUserStore(state => state.data);
  const isUserLogged = useUserStore(state => state.auth);
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get("url");
  const googleSignIn = () => {
    const path = getUserBaseUrl(role, true);
    showLoading();
    window.location.assign(`/api${path}/auth/google?host=${window.location.host}`);
    hideLoading();
  }
  //form of student data
  const userRef = useRef()
  const passRef = useRef()
  useEffect(() => {
    console.log(userData);
    let loginError = Cookies.get("error");
    if (loginError) {
      loginError = JSON.parse(loginError);
      if (Array.isArray(loginError)) {
        loginError.forEach(msg => {
          toast.error(msg, toastOptions);
        })
      }
      else {
        toast.error(loginError.toString(), toastOptions);
      }
      Cookies.remove("error");
    }
    if (isUserLogged) {
      const page = getNavLinks(userData.role).home;
      console.log(page);
      navigate(page);
    }
  }, [])
  const localLogin = (e) => {
    e.preventDefault();
    e.target.disabled = true;
    const path = getUserBaseUrl(role, true);
    showLoading();
    window.$.ajax({
      type: "post",
      url: `/api${path}/auth/local`,
      xhrFields: {
        withCredentials: true,
      },
      data: {
        username: userRef.current.value,
        password: passRef.current.value,
      },
      dataType: "json",
      success: (response, textStatus, request) => {
        console.log(response);
        hideLoading();
        e.target.disabled = true;
        if (!redirectUrl) {
          navigate(`${path}/`);
          return;
        }
        if (redirectUrl && redirectUrl.length > 1) {
          navigate(redirectUrl);
        }
      },
      statusCode: {

        404: function () {
          e.target.disabled = false;
          toast.error("page not found", toastOptions);
          hideLoading();
        },
        400: function (res) {
          e.target.disabled = false;
          if (!res.responseJSON) {
            toast.error("Something went wrong...", toastOptions);
            hideLoading();
            return;
          }
          hideLoading();
          toast.error(res.responseJSON.message, toastOptions);
          return;
        },
      },
      headers: {
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "",
      },
      error: function (res, textStatus, err) {
        handleXhrError(res, textStatus, err, () => {
          hideLoading();
          e.target.disabled = false;
        })
      },
    });
  }
  return (
    <div className="container-fluid">
      {/* <ToastContainer /> */}
      <div className="row">
        <div className="col-md-5 leftsignin">
          <img className="snistLogo" alt="logo" src="images/snistLogo.png" />
          <h3 className="powered">
            <span className="pby">Powered by</span>&ensp;
            <Logo />
          </h3>
        </div>
        <div className="col-md-7 rightsignin">
          <img className="snistLogoMobile" alt="logo" src="images/snistLogo.jpeg" />
          <h1 className="welcome">Welcome !</h1>
          <div
            className="col-10 col-md-6"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <h2 className="roledesc">What's your role?</h2>
            <select
              className="form-select signinOptions mb-3"
              aria-label="Default select example"
              value={role}
              onChange={(e) => setRole(e.target.value)}
            >
              <option value={ROLES.SUPER_ADMIN}>Super Admin</option>
              <option value={ROLES.ADMIN}>Admin (HOD)</option>
              <option value={ROLES.CO}>Class co-ordinator</option>
              <option value={ROLES.FACULTY}>Faculty</option>
              {/* <option value={ROLES.CR}>Class representative</option> */}
              <option value={ROLES.STUDENT}>Student</option>
            </select>
            <form style={{ width: "100%" }}>
              <div className="mb-3">
                <label htmlFor="exampleInputEmail1" className="form-label">
                  Email address
                </label>
                <input
                  type="email"
                  ref={userRef}
                  className="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  onChange={(e) => setEmail(e.target.value)}
                ></input>
                <div id="emailHelp" className="form-text">
                  We'll never share your email with anyone else.
                </div>
              </div>
              <div className="mb-3">
                <label htmlFor="exampleInputPassword1" className="form-label">
                  Password
                </label>
                <input
                  type="password"
                  ref={passRef}
                  className="form-control"
                  id="exampleInputPassword1"
                  onChange={(e) => setPassword(e.target.value)}
                ></input>
              </div>
            </form>
            <button className="mainSignin col-md-4" onClick={localLogin}>Signin</button>
          </div>
          <span className="orline  pt-1">--------------OR----------------</span>
          <button className="googlesignin" onClick={googleSignIn}>
            <img className="googleicon" alt="googleIcon" src="images/google.svg" />
            &ensp; Signin with google
          </button>
          {/* in mobile */}
          <h3 className="poweredmobile">
            <span className="pby">Powered by</span>&ensp;
            <Logo />
          </h3>
        </div>
      </div>
    </div>
  );
};

export default Signin;
